<template>
   <div class="pdd-box">
     <van-nav-bar
  title="拼多多商品搜索"
  left-arrow
  @click-left="$router.go(-1)"
/>
     <vueSearch @onSearch="goSearch"></vueSearch>
     <good v-for="(item,index) in goodList"
      :key="index" :good="item"></good>
    <div v-show="goodList.length === 0">
      <van-empty description="暂无搜索结果" />
    </div>
    <van-button type="default" size="large" v-show="page*20<total_results" @click="loadMore">加载更多</van-button>
   </div>
</template>

<script>
  import good from '@/components/pdd/good'
export default {
  components:{
    good,
  },
  data () {
    return {
     active:0,  //分类索引
     sortType:'',//排序
     keyword:'',  //搜索词
     goodList:[],  //商品列表
      total_results: 0, //总页数
      page: 1,
      catList:[], //分类列表
    }
  },
  created(){
    if(this.$route.query.q){
      this.onSearch(this.$route.query.q)
    }
  },
  methods:{
    // 获取数据
    getData(data){
      this.Post(data,'/pdd/api_goods_search',(res)=>{
        if(res.states==1){
          let good = res.data.goods_search_response.goods_list;
          this.goodList = this.goodList.concat(good);
          this.total_results = Number(res.data.goods_search_response.total_count);
        }
      })
    },
    // 复制链接
    doCopy(item) {
      this.$router.push('/pdd/share?id='+item.goods_id);
    },
    goSearch(keyword){
      this.$router.replace('/pdd/search?q='+keyword)
      this.onSearch(keyword)
    },
     // 搜索
    onSearch(keyword) {
      this.goodList = [];
      this.page = 1;
      this.total_results=0;
      this.keyword = keyword;
      let optId=0;
      if(this.active>0){
        optId=this.catList[this.active-1].opt_id;
      }
      let data = {
        q: this.keyword,
        opt_id:optId
      };
      this.getData(data);
    },
    // 分类搜索
    onTabChange(index,title){
      this.active=index;
      let optId=0;
      if(index>0){
        optId=this.catList[index-1].opt_id;
      }
      let data = {
        q: this.keyword,
        opt_id:optId
      };
      this.page = 1;
      this.total_results=0;
      this.goodList = [];
      this.getData(data);
    },
      // 排序筛选
    doSort(index, title) {

    },
     // 加载更多
    loadMore() {
      if (this.page * 20 < this.total_results) {
        this.page++;
        let data = {
          page: this.page,
          q: this.keyword
        };
        this.getData(data);
      }
    },
  }
}
</script>

<style lang="less" rel="stylesheet/less" scoped>
   .index-box{

   }
</style>



// WEBPACK FOOTER //
// src/pages/pdd/search.vue